import { Skeleton } from '@mui/material';
import { BrokerCard } from '../../styled';

export const MasterAdminCardSkeleton = () => (
  <BrokerCard>
    <Skeleton variant="circular" width={44} height={44} animation="wave" sx={{ flexShrink: 0 }} />
    <div style={{ flex: 1, minWidth: 0 }}>
      <Skeleton variant="text" width="60%" height={20} animation="wave" />
      <Skeleton variant="text" width="80%" height={16} animation="wave" />
    </div>
    <Skeleton variant="rounded" width={58} height={28} animation="wave" sx={{ flexShrink: 0 }} />
  </BrokerCard>
);
